import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const container = theme => css`
  margin: ${rem(186)} auto ${rem(32)};
  color: ${theme.color.monochrome.black};
  max-width: ${rem(396)};
`

const heading = theme => css`
  font-size: ${rem(19)};
  font-weight: ${theme.fontWeight.semibold};
  line-height: ${theme.lineHeight.leadingNormal};
  margin: 0 0 ${rem(8)};
`

const semibold = theme => css`
  font-weight: ${theme.fontWeight.semibold};
`

const field = theme => css`
  && {
    max-width: 100%;
    margin: ${rem(16)} 0 ${rem(10)};

    &:hover {
      & > * {
        border-color: ${theme.color.primary.info};
      }
    }
    .focused {
      border-color: ${theme.color.primary.info};
    }
    input {
      height: ${rem(48)};
      padding-left: ${rem(16)};
      font-size: ${theme.fontSize.x2large};

      &::placeholder {
        opacity: 0.5;
      }
    }
  }
`

const submitButton = css`
  width: 100%;
  border-radius: ${rem(24)};
`

const reEmail = theme => css`
  && {
    display: flex;
    justify-content: space-between;

    a {
      cursor: pointer;
      color: ${theme.color.brand['800']};

      &:hover {
        color: ${theme.color.brand['900']};
      }
    }
  }
`

export const styles = {
  container,
  heading,
  semibold,
  field,
  submitButton,
  reEmail,
}
